import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { shouldDisableCopilot } from 'owa-copilot-settings-store/lib/utils/shouldDisableCopilot';
import { getIsCopilotUIDisabled } from 'owa-mail-copilot-settings/lib/selectors/getIsCopilotUIDisabled';
import type { MailboxInfo } from 'owa-client-types';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getUserCohort } from 'owa-sidepane-bizchat-store/lib/selectors/getUserCohort';
import { UserCohort } from 'owa-bizchat-types/lib/UserCohort';

/**
 * Checks user preferences on displaying copilot and then checks if user has a Starter SKU
 */
export function isCopilotStarterSkuAndEnabledUser(mailboxInfoParam?: MailboxInfo): boolean {
    const mailboxInfo = mailboxInfoParam ?? getGlobalSettingsAccountMailboxInfo();

    if (shouldDisableCopilot(mailboxInfo) || getIsCopilotUIDisabled(mailboxInfo)) {
        return false;
    }
    return !isConsumer() && getUserCohort(mailboxInfo) === UserCohort.BCWAF;
}
